export default __webpack_public_path__ + "static/media/burrata_thumb.0d7692bf.jpg";